<link
  href="https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"
  rel="stylesheet"
/>

<div class="grid grid-cols-12 h-[100%]">
  <div class="col-span-12">
    <form
      (keydown)="preventSubmit($event)"
      [formGroup]="form"
      class="h-[100%] flex flex-col justify-between"
    >
      <div id="section-project-brief" class="mb-8">
        <div class="mb-4">
          <div class="sticky !bg-[#fff] top-0 !p-0">
            <div class="flex justify- items-center gap-8 !bg-[#dee2e6] p-4">
              <div
                class="flex justify-start items-center gap-8 top-0 !bg-[#dee2e6]"
              >
                <h3 class="project-brief">Project Brief</h3>
                <span
                  class="!ml-[10px] bg-[#F4F4F4] px-[20px] rounded-[0.625rem] text-[#343A40] roboto font-semibold"
                  >Intro</span
                >
              </div>

              <!-- Close Icon -->
              <div
                style="position: absolute; top: 10px; right: 36px; z-index: 50"
                (click)="closeDialog()"
              >
                <img
                  src="assets/icons/cross-icon.svg"
                  alt="cross icon"
                  class="cursor-pointer !fixed"
                />
              </div>
            </div>
            <div class="flex justify-end">
              <app-progress-bar
                [progress]="stage1Progress"
                [sectionId]="'section1'"
                [selectedSection]="selectedSection"
                [sectionName]="'Project Brief'"
              >
              </app-progress-bar>
            </div>
          </div>

          <div class="pt-[6px] pr-6 pb-6 pl-6 mx-[10px]">
            <div class="relative flex items-center !mb-5">
              <mat-form-field class="!w-[100%]" appearance="outline">
                <mat-label>Project Name </mat-label>
                <input
                  matInput
                  type="text"
                  id="name"
                  formControlName="name"
                  placeholder=" "
                />

                <mat-error
                  *ngIf="form.get('name')?.invalid && form.get('name')?.touched"
                >
                  Project Title is required.
                </mat-error>
              </mat-form-field>
            </div>

            <div class="flex items-center mt-[2.5rem]">
              <app-project-type
                [projectType]="parantProjectTypeName"
                [projectTypeId]="projectTypeParantId"
                [projectSubType]="childProjectTypeName"
                (changeProjectType)="addProjectType($event)"
                (changeProjectSubType)="addProjectSubType($event)"
                (customeTypeData)="customTypeData($event)"
              ></app-project-type>
            </div>

            <div style="margin-top: 20px; margin-left: 140px"></div>

            <div>
              <app-rich-textEditor
                (contentChange)="addProjectOutline($event)"
                [resetEditor]="resetRichTextEditor"
                [richTextValue]="form.get('outline')?.value"
                [placeHolder]="'Brief'"
                [label]="'Brief'"
              ></app-rich-textEditor>

              <div class="mb-4">
                <div class="relative flex items-center mt-[2rem]">
                  <mat-form-field class="!w-[100%]" appearance="outline">
                    <mat-label>Key Deliverables</mat-label>
                    <input
                      matInput
                      type="text"
                      formControlName="currentKeyDeliverable"
                      placeholder=""
                      (keydown.enter)="addKeyDeliverables()"
                      (blur)="addKeyDeliverables()"
                    />
                  </mat-form-field>
                </div>

                <div class="mt-[25px]">
                  <ul>
                    <div
                      *ngFor="let keyDeliverable of keyDeliverables"
                      class="flex"
                    >
                      <div
                        class="flex"
                        style="border-radius: 3px; border: 2px solid #eff8ff"
                      >
                        <span
                          class="ml-[] h-[22px] mr-[10px]"
                          style="border-radius: 3px; border: 1px #eff8ff"
                          >{{ keyDeliverable }}</span
                        >
                        <button
                          type="button"
                          class="justify-start"
                          (click)="removeKeyDeliverables(keyDeliverable)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 12 12"
                            fill="none"
                            style="margin-top: 3px"
                          >
                            <g filter="url(#filter0_d_4054_30471)">
                              <ellipse
                                cx="5.7573"
                                cy="3.99989"
                                rx="3.7573"
                                ry="3.99989"
                                fill="white"
                              />
                              <path
                                d="M9.01461 3.99989C9.01461 5.96276 7.52726 7.49978 5.7573 7.49978C3.98735 7.49978 2.5 5.96276 2.5 3.99989C2.5 2.03702 3.98735 0.5 5.7573 0.5C7.52726 0.5 9.01461 2.03702 9.01461 3.99989Z"
                                stroke="#AAD4F5"
                                stroke-opacity="0.15"
                              />
                            </g>
                            <path
                              d="M4.31152 5.53875L7.20176 2.46191M4.31152 2.46191L7.20176 5.53875"
                              stroke="#868E96"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <defs>
                              <filter
                                id="filter0_d_4054_30471"
                                x="0"
                                y="0"
                                width="11.5146"
                                height="12"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feOffset dy="2" />
                                <feGaussianBlur stdDeviation="1" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_4054_30471"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_4054_30471"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div
                      *ngFor="
                        let oldKeyDeliverable of oldKeyDeliverables;
                        let i = index
                      "
                      class="flex"
                    >
                      <div
                        class="flex"
                        style="border-radius: 3px; border: 2px solid #eff8ff"
                      >
                        <span
                          class="ml-[] h-[22px] mr-[10px]"
                          style="border-radius: 3px; border: 1px #eff8ff"
                          >{{ oldKeyDeliverable.name }}</span
                        >
                        <button
                          type="button"
                          class="justify-start"
                          (click)="removeOldKeyDeliverables(oldKeyDeliverable)"
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="25"
                            height="25"
                            viewBox="0 0 12 12"
                            fill="none"
                            style="margin-top: 3px"
                          >
                            <g filter="url(#filter0_d_4054_30471)">
                              <ellipse
                                cx="5.7573"
                                cy="3.99989"
                                rx="3.7573"
                                ry="3.99989"
                                fill="white"
                              />
                              <path
                                d="M9.01461 3.99989C9.01461 5.96276 7.52726 7.49978 5.7573 7.49978C3.98735 7.49978 2.5 5.96276 2.5 3.99989C2.5 2.03702 3.98735 0.5 5.7573 0.5C7.52726 0.5 9.01461 2.03702 9.01461 3.99989Z"
                                stroke="#AAD4F5"
                                stroke-opacity="0.15"
                              />
                            </g>
                            <path
                              d="M4.31152 5.53875L7.20176 2.46191M4.31152 2.46191L7.20176 5.53875"
                              stroke="#868E96"
                              stroke-width="1.5"
                              stroke-linecap="round"
                            />
                            <defs>
                              <filter
                                id="filter0_d_4054_30471"
                                x="0"
                                y="0"
                                width="11.5146"
                                height="12"
                                filterUnits="userSpaceOnUse"
                                color-interpolation-filters="sRGB"
                              >
                                <feFlood
                                  flood-opacity="0"
                                  result="BackgroundImageFix"
                                />
                                <feColorMatrix
                                  in="SourceAlpha"
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                                  result="hardAlpha"
                                />
                                <feOffset dy="2" />
                                <feGaussianBlur stdDeviation="1" />
                                <feComposite in2="hardAlpha" operator="out" />
                                <feColorMatrix
                                  type="matrix"
                                  values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                                />
                                <feBlend
                                  mode="normal"
                                  in2="BackgroundImageFix"
                                  result="effect1_dropShadow_4054_30471"
                                />
                                <feBlend
                                  mode="normal"
                                  in="SourceGraphic"
                                  in2="effect1_dropShadow_4054_30471"
                                  result="shape"
                                />
                              </filter>
                            </defs>
                          </svg>
                        </button>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="flex items-center justify-end mb-[30px] sticky">
        <button class="save-btn" type="button" (click)="handleSubmit('save')">
          <ng-container *ngIf="isLoadingSave; else normalTextSave">
            <div class="spinner"></div>
          </ng-container>
          <ng-template #normalTextSave>Save</ng-template>
        </button>
        <button
          class="next-btn"
          type="button"
          (click)="handleSubmit('next')"
          [ngClass]="{ 'loading-btn': isLoadingNext }"
        >
          <ng-container *ngIf="isLoadingNext; else normalTextNext">
            <div class="spinner"></div>
          </ng-container>
          <ng-template #normalTextNext>Next</ng-template>
        </button>
      </div>
    </form>
  </div>
</div>
